import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://kalorees.com';

const SEO = ({ 
  title = 'Kalorees - Free Health Calculators',
  description = 'Free health calculators for BMI, calorie intake, ideal weight, and calories burned. Evidence-based formulas with personalized results.',
  keywords = 'health calculator, BMI calculator, calorie calculator, ideal weight calculator, calories burned calculator, free health tools, nutrition calculator, fitness calculator',
  ogImage = '/images/og-image.webp',
  ogType = 'website',
  canonical = '',
  structuredData = null,
  noindex = false
}) => {
  const fullCanonical = canonical ? `${SITE_URL}${canonical}` : `${SITE_URL}${typeof window !== 'undefined' ? window.location.pathname : ''}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      )}
      
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${SITE_URL}${ogImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Kalorees" />
      <meta property="og:locale" content="en_US" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE_URL}${ogImage}`} />
      <meta name="twitter:creator" content="@Kalorees" />
      <meta name="twitter:site" content="@Kalorees" />
      
      <meta name="author" content="Kalorees Team" />
      <meta name="application-name" content="Kalorees" />
      <meta name="apple-mobile-web-app-title" content="Kalorees" />
      
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
